import { defineComponent as _defineComponent } from 'vue';
import InputNumber from 'primevue/inputnumber';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'InputNumber',
    props: {
        id: {
            type: String,
            required: true,
        },
        modelValue: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        unit: String,
        vuelidateObject: Object,
        disabled: {
            type: Boolean,
            default: false,
        },
        minFractionDigits: {
            type: Number,
            default: 0,
        },
        maxFractionDigits: {
            type: Number,
            default: 3,
        },
    },
    emits: ['update:modelValue'],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const invalid = computed(() => props.vuelidateObject ? props.vuelidateObject.$error : false);
        const __returned__ = { props, emit, invalid, get InputNumber() { return InputNumber; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
